<template>
	<div class="hospital-doctor-info">
		<div class="inputtopp">
			<div v-for="(item, index) of formdata" :key="index" class="search-item">
				<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
					:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
					:options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
					:color="item.color" :placeholder="item.placeholder" :multiple="item.multiple" :types="item.types"
					:inputtype="item.inputtype" :width="item.width" :event="item.event"
					@change="(val) => handleFormChange(val, index)">
				</Commondropdownlist>
			</div>
			<div class="Btngroups">
				<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
			</div>
		</div>

		<!-- Table -->
		<div class="table-container">
			<div class="btn-group" style="margin-bottom: 10px;">
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handleExport"
					:src="require('@/assets/icon/daoc.png')" />
			</div>
			<HospitalDoctorInfoTable :tableData="tableData"></HospitalDoctorInfoTable>
			<div class="pagination">
				<Pagination :total="total" :current="current" :pageSize="pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "@/components/common-dropdownlist.vue";
	import CommonBtngroup from "@/components/commongroup.vue";
	import Commonbtn from "@/components/common-btn.vue";
	import Pagination from "@/components/pagination.vue";
	import HospitalDoctorInfoTable from "./components/HospitalDoctorInfoTable.vue";
	import {
		HospitalDoctorInfoList,
		HospitalDoctorInfoExport
	} from "@/api/HospitalDoctorInfo";
	import {
		InventoryClassList
	} from "@/api/home";
	import {
		HelperLEVEL3ForItem
	} from "@/api/ActivityList";

	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			HospitalDoctorInfoTable
		},
		data() {
			return {
				formdata: [{
						title: "年度",
						inputtype: "date",
						inputdata: "",
						width: "180px",
						lablewith: "80px",
						placeholder: "请选择",
						fontSize: "14px",
						color: "#333333",
						types: "year"
					},
					{
						title: "产品线",
						inputtype: "select",
						inputdata: "",
						width: "180px",
						lablewith: "80px",
						placeholder: "请选择",
						fontSize: "14px",
						color: "#333333",
						options: []
					},
					{
						title: "医院",
						inputtype: "input",
						inputdata: "",
						width: "180px",
						lablewith: "80px",
						placeholder: "请输入",
						fontSize: "14px",
						color: "#333333"
					},
					{
						title: "术者",
						inputtype: "input",
						inputdata: "",
						width: "180px",
						lablewith: "80px",
						placeholder: "请输入",
						fontSize: "14px",
						color: "#333333"
					},
					{
						title: "重点产品",
						inputtype: "select",
						inputdata: "",
						width: "220px",
						lablewith: "100px",
						placeholder: "请选择",
						fontSize: "14px",
						color: "#333333",
						options: []
					}
				],
				tableData: [],
				total: 0,
				current: 1,
				pageSize: 10
			};
		},
		mounted() {
			this.getOptions();
			this.select();
		},
		methods: {
			async getOptions() {
				// 获取产品线
				let res = await InventoryClassList({});
				if (res.code == 0) {
					this.formdata[1].options = res.data.data.map(item => ({
						key: item.InvClass,
						value: item.InvClassName
					}));
				}
			},
			async handleFormChange(val, index) {
				// 产品线变更 (index === 1)
				if (index === 1) {
					// 重置 Level3 (index === 4)
					this.formdata[4].options = [];
					if (this.$refs.seselect && this.$refs.seselect[4]) {
						this.$refs.seselect[4].modelvalue = "";
					}

					if (!val) return;

					// 获取 Level3 选项
					let res = await HelperLEVEL3ForItem({
						InvClass: val
					});
					if (res.code == 0) {
						this.formdata[4].options = res.data.map(item => ({
							value: item.Text,
							key: item.Value
						}));
					}
				}
			},
			async select() {
				if (!this.$refs.seselect) return;

				let params = {
					Year: this.$refs.seselect[0] ? this.$refs.seselect[0].modelvalue : '',
					InvClass: this.$refs.seselect[1] ? this.$refs.seselect[1].modelvalue : '',
					Hospital: this.$refs.seselect[2] ? this.$refs.seselect[2].modelvalue : '',
					Doctor: this.$refs.seselect[3] ? this.$refs.seselect[3].modelvalue : '',
					Level3Code: this.$refs.seselect[4] ? this.$refs.seselect[4].modelvalue : '',
					PageIndex: this.current,
					PageSize: this.pageSize
				};

				// Year 可能是完整的日期字符串，如果只需要年份，可能需要截取
				if (params.Year && typeof params.Year === 'object') {
					params.Year = params.Year.getFullYear();
				} else if (params.Year && typeof params.Year === 'string' && params.Year.length > 4) {
					params.Year = params.Year.substring(0, 4);
				}

				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				try {
					let res = await HospitalDoctorInfoList(params);
					if (res.code == 0) {
						this.tableData = res.data.data.map(item => {
							// 格式化 CreateTime，截取时分秒 (yyyy-MM-dd)
							if (item.CreateTime && item.CreateTime.length > 10) {
								item.CreateTime = item.CreateTime.substring(0, 10);
							}
							return item;
						});
						this.total = res.data.total;
					} else {
						this.tableData = [];
						this.total = 0;
					}
				} finally {
					loading.close();
				}
			},
			reset() {
				if (this.$refs.seselect) {
					this.$refs.seselect.forEach(item => {
						item.modelvalue = "";
					});
				}
				
				// 清空重点产品选项
				this.formdata[4].options = [];
				
				this.current = 1;
				this.select();
			},
			handleCurrentChange(val) {
				this.current = val;
				this.select();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.select();
			},
			async handleExport() {
				if (!this.$refs.seselect) return;

				let params = {
					Year: this.$refs.seselect[0] ? this.$refs.seselect[0].modelvalue : '',
					InvClass: this.$refs.seselect[1] ? this.$refs.seselect[1].modelvalue : '',
					Hospital: this.$refs.seselect[2] ? this.$refs.seselect[2].modelvalue : '',
					Doctor: this.$refs.seselect[3] ? this.$refs.seselect[3].modelvalue : '',
					Level3Code: this.$refs.seselect[4] ? this.$refs.seselect[4].modelvalue : ''
				};

				if (params.Year && typeof params.Year === 'object') {
					params.Year = params.Year.getFullYear();
				} else if (params.Year && typeof params.Year === 'string' && params.Year.length > 4) {
					params.Year = params.Year.substring(0, 4);
				}

				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				try {
					let res = await HospitalDoctorInfoExport(params);
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});
					const fileName = '医院信息库.xlsx';
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = fileName;
					link.click();
					window.URL.revokeObjectURL(link.href);
				} catch (error) {
					this.$message.error('导出失败');
				} finally {
					loading.close();
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.hospital-doctor-info {
		.inputtopp {
			width: 100%;
			height: auto;
			min-height: 85px;
			box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
			background-color: #ffffff;
			padding-top: 15px;
			padding-bottom: 5px;
			position: relative;
			transition: all 0.3s;
			margin-bottom: 10px;
			display: flex;
			flex-wrap: wrap;
			align-items: flex-start;
		}

		.search-item {
			margin-right: 10px;
			margin-bottom: 10px;
		}

		.Btngroups {
			margin-left: auto;
			margin-top: 5px;
			margin-right: 20px;
			margin-bottom: 10px;
		}

		.table-container {
			background-color: #fff;
			padding: 10px;
			box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		}
	}
</style>
